// extracted by mini-css-extract-plugin
export var card = "_um-0";